import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICourseHoursRange, TCourseHoursRangeType } from '.';

export type TCreateCourseHoursRangeAsAdmin = {
  courseType: TCourseHoursRangeType;
  minValue: number;
  maxValue: number;
};

export type TAdminUpdateCourseHoursRange = {
  courseType: TCourseHoursRangeType;
  minValue: number;
  maxValue: number;
};

const apiDataProvider = new APIDataProvider();

const getCourseHoursRangeAsAdminModule = async () => {
  const path = `${AdminApiPaths.adminSettings}/hours-range`;
  const response = await apiDataProvider.get<TApiResponse<ICourseHoursRange>>(
    path
  );
  return response.data;
};

export const adminUpdateCourseHoursRange = createAsyncThunk(
  '/admin/course-hours-ranges/update-one',
  async (data: TAdminUpdateCourseHoursRange) => {
    const path = `${AdminApiPaths.adminSettings}/hours-range`;

    const response = await apiDataProvider.put<TApiResponse<ICourseHoursRange>>(
      path,
      data
    );

    return response.data;
  }
);

export const getCourseHoursRangeAsAdmin = createAsyncThunk(
  '/admin/course-hours-ranges/get-one',
  getCourseHoursRangeAsAdminModule
);
